export const popupCenter = (url, title, w, h) => {
    // Fixes dual-screen position                         Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    /*eslint-disable */
    const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
    const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;
    /*eslint-enable */

    const left = width / 2 - w / 2 + dualScreenLeft;
    const top = height / 2 - h / 2 + dualScreenTop;
    const newWindow = window.open(
        url,
        title,
        `htoolbar=no,resizable=yes,location=no,status=no,menubar=no,scrollbars=no,width=${w},height=${h},top=${top},left=${left}`
    );

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
};
